import { Injectable } from '@angular/core';
import { BaseclientService } from '../baseclient.service';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ToolsService } from '../../tools/tools.service';

@Injectable({
  providedIn: 'root'
})
export class ClientRefillsService {

  constructor(
    private baseClient: BaseclientService,
    private tools: ToolsService
  ) { }

  creditCard(paymentType: string | any, amount: number | any, card: any, merchantId: any, paypal_order_id?: string | any, payment_intent_id?: string | any): Promise<any> {
    const params: any = {
      payment_type: paymentType,
      amount: amount,
      merchant_id: merchantId,
    };

    /**
     * Stripe
     */
    if (paymentType === "online") {
      payment_intent_id ? params["payment_intent_id"] = payment_intent_id : params["payment_method_id"] = card.id;
    }

    /**
     * Paypal
     */
    if (paymentType === "online_paypal") {
      params["paypal_order_id"] = paypal_order_id ? paypal_order_id : null;
    }

    params['metadata'] = "3"; //provenance refill
    params["payment_intent_id_saved"] = this.tools.getStor("ClientKeyPayIntenCard") ? this.tools.getStor("ClientKeyPayIntenCard").id : null
    params["payment_intent_id_saved_stripe_widget"] = this.tools.getStor("ClientKeyPayIntentRefill") ? this.tools.getStor("ClientKeyPayIntentRefill").paymentIntent.id : null;


    return this.baseClient.postBase("creditCardSCA_", params);

  }

  refillsStripePayment(amount: number | any, merchantId: any, paymentIntentId?: any) {

    const params: any = {
      amount: amount,
      merchant_id: merchantId,
      paymentIntentId: paymentIntentId ? paymentIntentId : null
    };
    return this.baseClient.postBase("creditStripe", params);
  }


  stripeRefillPaymentSucceeded(client_recharge_id: any, payment_intent: any): Promise<any> {
    const params = {
      client_recharge_id: client_recharge_id,
      payment_intent: payment_intent

    };
    return this.baseClient.postBase("paymentRechargeSucceeded", params);
  }

  getOrderPaymentStripe(client_recharge_id: any, payment_intent: any): Promise<any> {
    const params = {
      payment_intent: payment_intent,
      id_data: client_recharge_id

    };
    return this.baseClient.postBase("getOrderPaymentStripe", params);
  }


  //yavin

  refillsYavinPayment(amount: number | any, merchantId: any) {

    const myurl = new URL(window.location.href);
    const params: any = {
      amount: amount,
      merchant_id: merchantId,
      url_success: myurl,
      url_cancelled: myurl
    };

    return this.baseClient.postBase("creditCardYavin", params);
  }

  yavinRefillPaymentSucceeded(client_recharge_id: any, status: any): Promise<any> {
    const params = {
      client_recharge_id: client_recharge_id,
      status: status
    };
    return this.baseClient.postBase("yavinPaymentRechargeSucceeded", params);
  }


  //mypos

  refillsMyposPayment(amount: number | any, merchantId: any) {

    const params: any = {
      amount: amount,
      merchant_id: merchantId,
    };

    return this.baseClient.postBase("creditCardMypos", params);
  }

  MyposRefillPaymentSucceeded(jsonMyPos: any, client_recharge_id: any): Promise<any> {
    const params = {
      jsonMyPos: jsonMyPos,
      client_recharge_id: client_recharge_id

    };
    return this.baseClient.postBase("PaymentRechargeSucceededMypos", params);
  }

  //Nepting

  refillsNeptingPayment(amount: number | any, merchantId: any) {

  

    const params: any = {
      amount: amount,
      merchant_id: merchantId,
      url: window.location.href

    };

    return this.baseClient.postBase("creditCardNepting", params);
  }






  getRefills(merchantId: any, dateFrom?: any, dateTo?: any): Observable<any> {
    const params = {
      merchant_id: merchantId,
      date_from: dateFrom,
      date_to: dateTo
    };
    return from(this.baseClient.postBase("getRefills_", params)).pipe(
      map(data => data.client_refills)
    );
  }

  getRecharge(id_user: any, rechargeId: number): Observable<any> {

    const params = {
      user_key:'0',
      recharge_id: rechargeId,
      id_user:id_user
    };
    return from(this.baseClient.postBase("getRecharge", params)).pipe(
      map(data => data.recharge)
    );
  }

  blockCard(merchantId: number): Promise<any> {
    const params = {
      merchant_id: merchantId
    };
    return this.baseClient.postBase("blockCard", params);
  }

  unblockCard(merchantId: number): Promise<any> {
    const params = {
      merchant_id: merchantId
    };
    return this.baseClient.postBase("unblockCard", params);
  }
}
